/**
 * Maps MIME types that some backends report for media files to the canonical
 * `video/*` / `audio/*` type expected by browsers (for `<source type>`) and by
 * this app's playable-media detection (`startsWith('video/')` / `startsWith('audio/')`).
 *
 * e.g. some mime databases resolve `.mp4` to `application/mp4` instead of `video/mp4`,
 * which browsers don't recognize as a playable video source.
 */
const MEDIA_CONTENT_TYPE_ALIASES: Record<string, string> = {
  'application/mp4': 'video/mp4',
}

export function normalizeMediaContentType(contentType: string): string {
  const [base] = contentType.toLowerCase().split(';', 1)
  return MEDIA_CONTENT_TYPE_ALIASES[base.trim()] ?? contentType
}

